<template>
<v-layout row justify-center>
  <v-dialog v-model="controlDialogVisible" :max-width="width" :persistent="!closeWithMask">
    <v-card>
      <v-card-title class="headline">
        {{$t('views.titles.resetPassword')}}
      </v-card-title>
      <v-card-text>
        Digite abaixo o email cadastrado no sistema.
        <v-text-field :label="$t('attributes.email')" v-model="reset.email" :counter="100"
          :error-messages="validationErrors.email">
        </v-text-field>

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="close">{{$t('views.actions.getOut')}}</v-btn>
        <v-btn flat color="primary" dark @click="send">{{$t('views.actions.send')}}</v-btn>
      </v-card-actions>
      </v-card>
  </v-dialog>
</v-layout>
</template>

<script>
import DialogMixin from '@/components/mixins/DialogMixin';

export default {
  name: 'recover-password-dialog',
  data() {
    return {
      validationErrors: {},
      reset: {},
    };
  },
  mixins: [DialogMixin],
  methods: {
    send() {
      this.$store.dispatch('recoverPassword', this.reset).then(() => {
        this.$toast.success(this.$t('messages.recoveryPassword.sendMailSuccess'));
        this.hide();
      }).catch((error) => {
        this.valdationErrors = error.response.data;
      });
    },
    close() {
      this.valdationErrors = {};
      this.closeDialog();
    },
  },
  mounted() {
    this.valdationErrors = {};
  },
};
</script>



// WEBPACK FOOTER //
// src/features/auth/RecoverPasswordDialog.vue